import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { Button } from "components/Button";
import { SelectLanguage } from "components/SelectLanguage";

export const StyledLanguageSelector = styled(SelectLanguage)`
  margin-bottom: 1rem;
`;

export const StyledMigrationNotice = styled.article`
  color: ${(props: ThemeProps) => props.theme.palette.neutral._400};
`;

export const StyledButton = styled(Button)`
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  margin-bottom: 1rem;
`;

export const StyledSURFconextButton = styled(StyledButton)`
  border-color:  ${(props: ThemeProps) => props.theme.palette.neutral.black};

  img {
    height: ${(props: ThemeProps) => props.theme.font.size._16};
  }

  .content {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledSection = styled.section`
  margin-top: 2.5rem;

  h4 {
    font-size: ${(props: ThemeProps) => props.theme.font.size._18};
    line-height: 100%;
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const StyledSeparator = styled.div<ThemeProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  text-transform: uppercase;
  color: ${(props: ThemeProps) => props.theme.palette.neutral._400};

  margin: 2rem 0;
  ~ section {
    margin: 0;
  }

  ::before {
    content: '';
    height: 1px;
    width: 15rem;
    background-color: ${(props: ThemeProps) => props.theme.palette.neutral._500};
    display: block;
    margin-right: 1rem;
  }

  ::after {
    content: '';
    height: 1px;
    width: 15rem;
    background-color: ${(props: ThemeProps) => props.theme.palette.neutral._500};
    display: block;
    margin-left: 1rem;
  }
`;
